var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "html-5_5968267 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5547 0H29.7656V5.16562H34.5688V0H39.7797V15.6328H34.5688V10.4219H29.8109V15.6328H24.5547V0ZM46.6672 5.21094H42.068V0H56.5V5.21094H51.8781V15.6328H46.6672V5.21094ZM58.7883 0H64.2484L67.6016 5.50547L70.9547 0H76.4148V15.6328H71.2039V7.88437L67.5563 13.5031L63.9086 7.88437V15.6328H58.7883V0ZM78.9977 0H84.2086V10.4672H91.5945V15.6328H78.9977V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.375 106.712L16.8984 22.793H99.0953L91.6187 106.666L57.9289 116.001",
    fill: "#FF4C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58 108.863V29.6797H91.5992L85.1875 101.273L58 108.863Z",
    fill: "#FF651E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.1719 39.9414H58L61.8405 45.0844L58 50.2273H43.4547L44.4063 60.7625H58L61.8405 66.0978L58 71.0258H34.9812L32.1719 39.9414ZM35.4344 76.1914H45.7656L46.4906 84.4156L58 87.4969L62.3335 92.6308L58 98.2359L36.8844 92.3453L35.4344 76.1914Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M83.7359 39.9414H57.9531V50.2273H82.7844L83.7359 39.9414ZM81.8555 60.7625H57.9531V71.0484H70.6406L69.4398 84.4156L57.9531 87.4969V98.1906L79.0234 92.3453L81.8555 60.7625Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.773fc4e238e380bcbeb788821a403cbf.svg";
export { ForwardRef as ReactComponent };